<template>
  <div class="column-area  mb20">
    <div class="wrapper_main">
      <!--推荐古籍-->
      <div class="paper_title">
        <span class="title_font">推荐古籍</span>
      </div>
      <!-- 列表区域  -->
      <div class="pager-list">
        <el-row>
          <el-col :span="4.4" v-for = "(item,index) in ancientResourceList" :key="item.id" :offset="index === 0 ? 0 : (index%5 === 0 ? 0:0.8)">
            <el-card  class="book-card" :body-style="{ padding: '0px' }"  @click.native="openAncientResource(index)"  title="点击阅读">
              <a href="#"><img class="book-cover" :src="item.virtualRoute+item.resourceCover"/></a>
              <span class="book_favitor" v-if="item.state==1"><i class="iconfont icon-award-fill"/></span>
              <div class="book_title">
                <span>{{item.resourceName}}</span>
                <span>({{item.subName}})</span>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <!--推荐报刊-->
      <div class="paper_title">
        <span class="title_font">推荐报刊</span>
      </div>
      <!-- 列表区域  -->
      <div class="pager-list">
        <el-row>
          <el-col :span="4.4" v-for = "(item,index) in newPageResourceList" :key="item.id" :offset="index === 0 ? 0 : (index%5 === 0 ? 0:0.8)">
            <el-card  class="book-card" :body-style="{ padding: '0px' }"  @click.native="openNewPaperPage(index)"  title="双击跳转页面">
              <a href="#"><img class="book-cover" :src="item.virtualRoute+item.resourceCover"/></a>
              <span class="book_favitor" v-if="item.state==1"><i class="iconfont icon-award-fill"/></span>
              <div class="book_title">
                <span>{{item.resourceName}}</span>
                <span>({{item.subName}})</span>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <!--推荐图书-->
      <div class="paper_title">
        <span class="title_font">推荐图书</span>
      </div>
      <!-- 列表区域  -->
      <div class="pager-list">
        <el-row>
          <el-col :span="4.4" v-for = "(item,index) in bookResourceList" :key="item.id" :offset="index === 0 ? 0 : (index%5 === 0 ? 0:0.8)">
            <el-card  class="book-card" :body-style="{ padding: '0px' }"  @click.native="openBookResource(index)"  title="双击跳转页面">
              <a href="#"><img class="book-cover" :src="item.virtualRoute+item.resourceCover"/></a>
              <span class="book_favitor" v-if="item.state==1"><i class="iconfont icon-award-fill"/></span>
              <div class="book_title">
                <span>{{item.resourceName}}</span>
                <span>({{item.subName}})</span>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  import resourceApi from "@/api/resource"
  import searchkeyApi from "@/api/searchkey"
  import middle_banner from '@/assets/site-image/ad.jpg'
  import configJosn from "../../../static/config.json";
  import {Message} from "element-ui";

  export default {
    name: 'bookColumn',
    data() {
      return{
        ancientResourceList : [],
        newPageResourceList : [],
        bookResourceList : [],
        middle_banner: middle_banner,
        queryEntity:{
          keyword: "",
          current: 1,
          pages: null,
          sizes: 6,
          total: 0,
          extInt:1,
          orderField: "useCount",
        },
        searchTypeList: [
          {value: 0, label: "标题检索"},
          {value: 1, label: "全文检索"},
        ]
      }

    },
    inject: ["provideData"],
    props: {
      dataList: {
        type: [Object],
      }
    },
    created() {
      this.initData()
    },
    mounted(){
      console.log(this.dataList.title);
    },
    methods:{
      initData(){
        this.queryEntity.sizes = 5;
        resourceApi.getHomeResourceByQueryEntity(this.queryEntity).then(res => {
          this.ancientResourceList = res.data.ancientResourceList.list;
          this.newPageResourceList = res.data.newPageResourceList.list;
          this.bookResourceList = res.data.bookResourceList.list;
        });
      },
      openAncientResource: function(index){
        //const href = this.ancientResourceList[index].virtualRoute+this.ancientResourceList[index].resourceAddress;
        //window.open(href, '_blank');
        this.openReadPage(this.ancientResourceList[index])
        this.tableLoading = false;
      },
      openNewPaperPage: function (index) {
        //const href = this.newPageResourceList[index].virtualRoute+this.newPageResourceList[index].resourceAddress;
        //window.open(href, '_blank');
        this.openReadPage(this.newPageResourceList[index])
        this.tableLoading = false;
      },
      openBookResource: function(index){
        //const href = this.bookResourceList[index].virtualRoute+this.bookResourceList[index].resourceAddress;
        //window.open(href, '_blank');
        this.openReadPage(this.bookResourceList[index])
        this.tableLoading = false;
      },
      openReadPage(selectObject){
        let bookGuid = selectObject.guid
        let bookName = selectObject.resourceName
        let bookState = selectObject.state
        if (bookState == undefined || bookState == null){
          bookState = 0
        }
        let bookUrl = selectObject.virtualRoute+selectObject.resourceAddress;
        //let bookUrl = "bookvirtual/8ef221e60c66444984539a6afd19RjheZPXr/1c300a8ea3f04761bc65c7fd8a48QfrUvc5T/09011927.pdf"
        const { href } = this.$router.resolve({
          name: "readpage",
          query: {
            bookGuid:bookGuid,
            bookName:bookName,
            bookState:bookState,
            bookUrl:bookUrl,
          },
        });
        window.open(href, '_blank');
        this.tableLoading = false;
      },
      changeEditSearchKeyWord(){
        this.inputKeyWord = this.editSearchKeyWord;
      },

      clickKeyWordQuery(){
        if (this.inputKeyWord!=null && this.inputKeyWord.trim()!=''){
          this.inputKeyWord = this.editSearchKeyWord;
          this.$emit('clickSearchData',this.selectSearchType,this.inputKeyWord)
        }else{
          Message.info("请输入要检索的关键字。");
        }
      },
      clickHistoryKeyword(keyword){
        if (keyword!=null && keyword.trim()!=''){
          this.$emit('clickSearchData',this.selectSearchType,keyword)
        }else{
          Message.info("请输入要检索的关键字。");
        }
      },
      changeSearchType(selectItem){
        this.selectSearchType = selectItem;
        this.getSearchKeyList();
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import url('../../styles/common.css');
  @import url('../../styles/main.css');
</style>



// WEBPACK FOOTER //
// src/view/column/bookcolumn.vue